/* eslint-disable */
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

// Layout Types
import { Builder, SidebarLayout } from './components'

// Route Views
import { getSidebarItems } from './data'

import { DeviceConfigContainer, MLPContainer, StationViewContainer } from './views'
import { LotContainer } from './views/Lot'
import { SearchConfigContainer } from './views/SearchConfig/SearchConfigContainer'
import { OverrideTraficLight } from './views/OverrideTraficLight'
import { MatchingFlagContainer } from './views/MatchingFlag'
import { OccupancyApiTestContainer } from './views/OccupancyApiTest'
import { AccessControlDeviceDetailContainer } from './views/AccessControl'

const ROUTES = [
    { path: '/device', component: DeviceConfigContainer },
    { path: '/tl', component: OverrideTraficLight },
    { path: '/station', component: StationViewContainer },
    { path: '/lot', component: LotContainer },
    { path: '/mlp', component: MLPContainer },
    { path: '/searchConfig', component: SearchConfigContainer },
    { path: '/formEdit/:formName', component: Builder },
    { path: '/matchingFlag', component: MatchingFlagContainer },
    { path: '/occupancyApiTest', component: OccupancyApiTestContainer },
    { path: '/AC', component: AccessControlDeviceDetailContainer }
]

const Routes = () => {
    return (
        <SidebarLayout sidebarProps={{ navItems: getSidebarItems() }}>
            <Switch>
                {ROUTES.map((route, idx) => (
                    <Route key={idx} {...route} />
                ))}
                <Route path="/" component={() => <Redirect to="/lot" />}></Route>
            </Switch>
        </SidebarLayout>
    )
}

export default Routes
